(function (global, Reverb) {
  Reverb = Reverb || {};
  Reverb.Offers = Reverb.Offers || {};

  var NAMESPACE = 'makeAnOffer';
  var MAKE_OFFER_ID = '#inline-make-offer';
  var TOGGLE_CLASSES = 'make-offer-open';

  Reverb.Offers.InlineOffer = (function () {
    function bindOfferCancelToggle() {
      var $icon = $('<i class="fa fa-remove"></i>');

      $(document).on('click.' + NAMESPACE, MAKE_OFFER_ID, function () {
        var CANCEL = I18n.t('js.inlineOffer.cancel');
        var MAKE_OFFER = I18n.t('js.inlineOffer.makeAnOffer');
        var $button = $(this);

        $button.toggleClass(TOGGLE_CLASSES);
        // Remove whitespace to test for contains text
        if ($button.text().replace(/ /g, '') === CANCEL) {
          $button.empty();
          $button.text(MAKE_OFFER);
        } else {
          $button.text(CANCEL);
          // adds space before icon
          $button.prepend(' ');
          $button.prepend($icon);
        }
      });
    }

    return {
      init: bindOfferCancelToggle
    };
  })();

  $(Reverb.Offers.InlineOffer.init);
})(window, window.Reverb);



// WEBPACK FOOTER //
// ./javascripts/components/legacy/offers/inline_offer.js